export default __webpack_public_path__ + "static/media/Pikachu_Caminando.a4704ab5.gif";